const TestDurumEnum = {
    1: 'Oluşturuldu',
    2: 'Kullanıcıya İletildi',
    3: 'Yanıtlandı',
    '-1': 'İptal',
    Olusturuldu: 1,
    KullaniciIletildi: 2,
    Yanitlandi: 3,
    Iptal: -1
};

export default TestDurumEnum; 